import type { Provider } from '@angular/core';
import { BulkCompileService } from './bulk-compile.service';
import { CompilingFormService } from './compiling-form.service';
import { CompilingPointsService } from './compiling-points.service';
import { EvaluationRequestService } from './evaluation-request.service';
import { FormRulesService } from '../rules/form-rules.service';
import { AnswerAttachmentsService } from './state/answer-attachments.service';
import { AnswerPermissionsService } from './state/answer-permissions.service';
import { AutoCompileStateService } from './state/auto-compile-state.service';
import { PefStateService } from './state/pef-state.service';
import { TenderContextService } from './state/tender-context.service';

/**
 * Provides the compiling state for one page.
 *
 * These are deliberately component-scoped, not `providedIn: 'root'`: each holds
 * the state of a single tender answer, and a singleton would leak the previous
 * one into the next page.
 */
export function provideCompiling(): Provider[] {
  return [
    FormRulesService,
    CompilingFormService,
    CompilingPointsService,
    TenderContextService,
    AnswerAttachmentsService,
    AnswerPermissionsService,
    PefStateService,
    AutoCompileStateService,
    BulkCompileService,
    EvaluationRequestService,
  ];
}
